import React, { memo, forwardRef } from "react";
const SvgOpeninterval = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M1.972 20.908C1.324 18.874 1 17.804 1 15.698s.324-3.167.972-5.183c.648-2.034 1.503-3.807 2.565-5.319.216-.306.468-.459.756-.459.234 0 .432.081.594.243a.722.722 0 01.243.567c0 .18-.072.387-.216.621C4.96 7.644 4.195 9.3 3.619 11.136c-.558 1.836-.837 2.69-.837 4.562 0 1.872.279 2.726.837 4.562.576 1.836 1.341 3.492 2.295 4.968.144.234.216.441.216.621a.722.722 0 01-.243.567.808.808 0 01-.594.243c-.288 0-.54-.153-.756-.459-1.062-1.512-1.917-3.276-2.565-5.292zM17.438 21.043l-1.54 4.698c-.161.468-.44.702-.836.702a.935.935 0 01-.648-.243.72.72 0 01-.27-.594c0-.144.027-.306.08-.486l1.432-4.617c.144-.522.45-.783.918-.783.27 0 .495.081.675.243.18.162.27.378.27.648 0 .09-.027.234-.081.432zM29.871 10.515c.648 2.016.972 3.077.972 5.183s-.324 3.176-.972 5.21c-.648 2.016-1.503 3.78-2.565 5.292-.216.306-.468.46-.756.46a.808.808 0 01-.594-.244.722.722 0 01-.243-.567c0-.18.072-.387.216-.62.954-1.477 1.71-3.133 2.268-4.969.576-1.836.864-2.69.864-4.562 0-1.872-.288-2.726-.864-4.562-.558-1.836-1.314-3.492-2.268-4.968-.144-.234-.216-.44-.216-.62 0-.235.081-.424.243-.568a.808.808 0 01.594-.243c.288 0 .54.153.756.46 1.062 1.511 1.917 3.284 2.565 5.318z"
      />
    </svg>
  );
});
SvgOpeninterval.displayName = "SvgOpeninterval";
const MemoForwardRef = memo(SvgOpeninterval);
export default MemoForwardRef;
